import * as React from 'react';

const SvgLocation = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.99996 8.66666C9.10453 8.66666 9.99996 7.77123 9.99996 6.66666C9.99996 5.56209 9.10453 4.66666 7.99996 4.66666C6.89539 4.66666 5.99996 5.56209 5.99996 6.66666C5.99996 7.77123 6.89539 8.66666 7.99996 8.66666Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99996 14.6667C10.6666 12 13.3333 9.61218 13.3333 6.66666C13.3333 3.72114 10.9455 1.33333 7.99996 1.33333C5.05444 1.33333 2.66663 3.72114 2.66663 6.66666C2.66663 9.61218 5.33329 12 7.99996 14.6667Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgLocation;
